export const secondsToMinute = (seconds: number) => {
  const minutes = seconds / 60
  return minutes >= 10 ? minutes : `0${minutes}`
}
